import { render, staticRenderFns } from "./BusiestDayStats.vue?vue&type=template&id=2f68351c&"
import script from "./BusiestDayStats.vue?vue&type=script&lang=js&"
export * from "./BusiestDayStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports